import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Navbar from '../components/Navbar'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles({

    root: {
        backgroundColor: 'white',
        padding: '16px',
        marginTop: '30px',
        overflow: 'hidden',
        maxWidth: '320px',
        width: '100%',
        height: '160px',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column'

    },

    title: {
        color: '#cb4982',
        width: '100%',
        borderBottom: '1px solid #cb4982',
        marginBottom: '16px'
    },

    flexContainer: {
        display: 'flex',
        height: '80%',
        justifyContent: 'center',
        alignItems: 'center'

    },

    button: {
        alignSelf: 'flex-end',
        width: 'auto'

    },

    link: {
        color: 'white',


        '&:hover': {
            textDecoration: 'none'
        }
        
    }
})


const NotFound = () => {

    const classes = useStyles()

    return (
        <>
            <Navbar type="default" />

            <Container className={classes.flexContainer}>
                <Paper className={classes.root}>
                    <div className="">
                    <Typography variant="h6" color="error" className={classes.title}>
                        Página não encontrada
                            </Typography>
                        
                    </div>

                        <Button variant="contained" className={classes.button} size="large" color="primary">
                            <Link href="/" className={classes.link}>Ir para meus cursos</Link>
                        </Button>

                </Paper>
            </Container>

        </>
    )

}


export default NotFound